module.exports = __webpack_public_path__ + "static/media-routing-number-53a9677dee279875bd6bca1bb333eebc.png";